import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    i18nLocale: 'zhHans',
    userInfo: {},
    //菜单条状态
    drawer: false,
    maxHeight:500,
    tabItem:[{
          name: "主页",
          href: "/home"
        }],
    menuItems: [{
      "id": "006",
      "permissionOrder": 7,
      "icon": "mdi-book-open-page-variant",
      "iconType": "0",
      "name": "培训业务",
      "href": "",
      "code": "peixun",
      "active": "true",
      "items": [{
        "id": "006001",
        "permissionOrder": 0,
        "icon": "mdi-teach",
        "iconType": "0",
        "name": "师资团队",
        "href": "/team",
        "code": "teacher",
        "items": null
      }, {
        "id": "006002",
        "permissionOrder": 1,
        "icon": "mdi-language-java",
        "iconType": "0",
        "name": "课程计划",
        "href": "/course",
        "code": "course",
        "items": null
      }, {
        "id": "006003",
        "permissionOrder": 2,
        "icon": "mdi-podium-gold",
        "iconType": "0",
        "name": "就业金榜",
        "href": "/work",
        "code": "gold",
        "items": null
      }]
    }, {
      "id": "007",
      "permissionOrder": 8,
      "icon": "mdi-contacts-outline",
      "iconType": "0",
      "name": "外包服务",
      "href": "",
      "code": "waibao",
      "items": [{
          "id": "007001",
          "permissionOrder": 1,
          "icon": "mdi-electron-framework",
          "iconType": "0",
          "name": "业务简介",
          "href": "/businessProfile",
          "code": "businessProfile"
        },
        {
          "id": "007002",
          "permissionOrder": 2,
          "icon": "mdi-briefcase-search-outline",
          "iconType": "0",
          "name": "服务案例",
          "href": "/serviceCase",
          "code": "serviceCase"
        },
      ]
    }, {
      "id": "008",
      "permissionOrder": 9,
      "icon": "mdi-bug-check",
      "iconType": "0",
      "name": "研发业务",
      "href": "",
      "code": "yanfa",
      "items": [{
        "id": "008001",
        "permissionOrder": 0,
        "icon": "mdi-television-guide",
        "iconType": "0",
        "name": "服务案例",
        "href": "/research",
        "code": "project",
        "items": null
      }]
    }, {
      "id": "009",
      "permissionOrder": 10,
      "icon": "mdi-camera-wireless",
      "iconType": "0",
      "name": "易途情节",
      "href": "",
      "code": "et",
      "items": [{
        "id": "009001",
        "permissionOrder": 0,
        "icon": "mdi-camera",
        "iconType": "0",
        "name": "精彩时刻 ",
        "href": "/plot",
        "code": "plot",
        "items": null
      }, {
        "id": "009002",
        "permissionOrder": 1,
        "icon": "mdi-video",
        "iconType": "0",
        "name": "精彩回忆",
        "href": "/video",
        "code": "video",
        "items": null
      }]
    }, {
        "id": "010",
        "permissionOrder": 11,
        "icon": "mdi-alpha-e-circle",
        "iconType": "0",
        "name": "关于我们",
        "href": "/about",
        "code": "about",
        "items": []
      },{
      "id": "011",
      "permissionOrder": 12,
      "icon": "mdi-card-account-phone",
      "iconType": "0",
      "name": "联系我们",
      "href": "/contact",
      "code": "lianxiwomen",
      "items": []
    }],
  },
  mutations: {
    set_token(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    del_token(state) {
      state.token = ''
      localStorage.setItem('token', '')
    },
    changeI18n(state, i18n) {
      state.i18nLocale = i18n
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    changeDrawerOff(state) {
      setTimeout(function() {
        state.drawer = false
      }, 500)
    },
    changeDrawerOn(state) {
      setTimeout(function() {
        state.drawer = true
      }, 500)
    },
    reverseDrawer(state) {
      state.drawer = !state.drawer
    },
    setMenuItems(state, items) {
      state.menuItems = items
    },
    setMaxHeight(state,height){
      state.maxHeight = height
    },
    spliceTabItem(state,item){
      state.tabItem.splice(state.tabItem.indexOf(item), 1)
    },
    addTabItem(state,item){
      state.tabItem.push(item)
    }

  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js